module.exports = __webpack_public_path__ + "img/22.4b6e89a0.jpg";